module.exports = __webpack_public_path__ + "img/set_theme_6.e863dd14.png";